import React from "react";
import {WebService} from "../../module/WebService";
import {AppConfig} from "../../AppConfig";
import LoadingImage from "../LoadingImage";
import {Grid, GridColumn, GridToolbar} from '@progress/kendo-react-grid';
import {ExcelExport} from '@progress/kendo-react-excel-export';
import '@progress/kendo-theme-material/dist/all.css';
import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class ReportDetail extends React.Component {

    webService = new WebService();
    urlSearchParams = new URLSearchParams(window.location.search);

    _export;
    export = () => {
        this._export.save();
    };

    constructor(props) {
        super(props);
        this.state = {serviceState: -1};
        this.serviceName = "report/" + this.urlSearchParams.get("name");
        this.getData();
    }

    getData() {
        const header = {headers: {Authorization: 'Bearer ' + cookies.get(AppConfig.cookie.token)}};

        axios.get(AppConfig.server + this.serviceName, header)
            .then((res) => {
                this.success(res.data);
            })
            .catch((error) => {
                this.fail();
            });
    }

    success = (data)=>{
        if (data.length > 0) {
            this.data = data;
            this.setState({
                serviceState: 1
            });
        }
        else
            this.fail();
    }

    fail = ()=>{
        this.setState({
            serviceState: 2
        });
    }


    render() {
        if (this.state.serviceState === 1) {

            return (
                <div style={{width: "100%"}}>
                    <h3><strong>Rapor</strong></h3>
                    <hr/>


                    {/*<table className="table">
                        <thead>
                        {this.renderReportHeader()}
                        </thead>
                        <tbody>
                        {this.renderReportRow()}
                        </tbody>
                    </table>*/}

                    {this.renderContent()}

                </div>
            )
        }
        else if (this.state.serviceState === -1) {
            return (
                <LoadingImage/>
            )
        }
        else {
            return (
                <strong style={{display: "block", textAlign: "center"}}>Rapor bulunamadı</strong>
            )
        }
    }


    renderContent() {
        const name = this.urlSearchParams.get("name");
        if (name === "reportUserAndFinishedWork") {
            return (
                <ExcelExport
                    data={this.data}
                    ref={exporter => this._export = exporter}>
                    <Grid data={this.data}>
                        <GridToolbar>
                            <button
                                title="Excel Çıkar"
                                className="k-button k-primary"
                                onClick={this.export}>
                                Excel Çıkar
                            </button>
                        </GridToolbar>
                        <GridColumn field="username" title="Operator Adı"/>
                        <GridColumn field="callName" title="Çağrı Tipi"/>
                        <GridColumn field="machineName" title="Makina Adı"/>
                        <GridColumn field="startTime" title="Başlama Zamanı"/>
                        <GridColumn field="finishTime" title="Bitirme Zamanı"/>
                        <GridColumn field="elapsedTime" title="Bitirme Süresi"/>
                    </Grid>
                </ExcelExport>
            )
        }
        else if (name === "userWorkReport") {
            return (
                <ExcelExport
                    data={this.data}
                    ref={exporter => this._export = exporter}>
                    <Grid data={this.data}>
                        <GridToolbar>
                            <button
                                title="Excel Çıkar"
                                className="k-button k-primary"
                                onClick={this.export}>
                                Excel Çıkar
                            </button>
                        </GridToolbar>
                        <GridColumn field="registryNo" title="Sicil No."/>
                        <GridColumn field="name" title="İsim"/>
                        <GridColumn field="lastWorkName" title="Son Yapılan İş"/>
                        <GridColumn field="lastStartTime" title="Baş.Zamanı"/>
                        <GridColumn field="lastFinishTime" title="Bit.Zamanı"/>
                        <GridColumn field="workCountToday" title="Bugünki İşlemler"/>
                        <GridColumn field="workingToday" title="Bugün?"/>
                    </Grid>
                </ExcelExport>
            )
        }
        else
            return (
                <strong style={{display: "block", textAlign: "center"}}>Rapor bulunamadı</strong>)
    }

    /*renderReportHeader(){
        return(
            <tr>
                <th scope="col">Operator Adı</th>
                <th scope="col">Çağrı Tipi</th>
                <th scope="col">Makina Adı</th>
                <th scope="col">Başlama Zamanı</th>
                <th scope="col">Bitiş Zamanı</th>
            </tr>
        )
    }
    renderReportRow() {
        const row = [];
        for (let i = 0; i < this.data.length; i++) {
            const currentData = this.data[i];

            row.push(<tr>
                <th>{currentData["username"]}</th>
                <td>{currentData["callName"]}</td>
                <td>{currentData["machineName"]}</td>
                <td>{currentData["startTime"]}</td>
                <td>{currentData["finishTime"]}</td>
            </tr>)
        }

        return row;
    }*/

}

export default ReportDetail;
